export default __webpack_public_path__ + "static/media/location.6d3b7b16.svg";